import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 30, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionTag = ({ children }) => (
  <span
    className="inline-flex items-center gap-2 text-xs font-bold tracking-[0.25em] uppercase"
    style={{ color: "var(--primary)" }}
  >
    <span className="h-px w-8" style={{ background: "var(--primary)" }} />
    {children}
  </span>
);
